/**
 * Cuál de los stores del filtro compartido usa la bandeja.
 *
 * El filtro de store es **uno solo para toda la app** —Quotes, Contactos, Pedidos y Conversaciones
 * leen el mismo contexto, persistido en `localStorage`—, pero es **multi**-select y la bandeja de
 * Conversaciones es de a un store por vez.
 *
 * La regla: el **primero de los elegidos al que el operador tenga acceso acá**. "Acceso acá" no es
 * lo mismo que en Contactos: un operador puede filtrar por un store donde ve contactos pero no
 * tiene ningún canal de WhatsApp.
 *
 * Devuelve `undefined` cuando ninguno aplica. Ese caso importa: el llamador se cae a su default
 * (el primer store con canales) y **no toca la selección compartida**. Pisarla borraría un filtro
 * que el operador puso en otra pantalla.
 */
export function storeDeLaBandeja(
  elegidos: { code: string }[],
  accesibles: string[],
): string | undefined {
  const disponibles = new Set(accesibles);
  return elegidos.map((s) => s.code).find((code) => disponibles.has(code));
}
